import { Backdrop } from '@mui/material';
import AppContainer from 'components/app-container';
import UPLoadingSpinner from 'components/loading-spinner';
import Auth from 'modules/auth';
import SetManagerPassword from 'modules/auth/SetManagerPassword';
import SetPassword from 'modules/auth/SetPassword';
import SetPasswordApp from 'modules/auth/SetPasswordApp';
import MfaChallenge from 'modules/auth/mfa-challenge';
import MfaEnrollment from 'modules/auth/mfa-enrollment';
import AuthRedirect from 'modules/authRedirect';
import EmployeeApp from 'modules/employees/add-edit-employee-modal/EmployeeApp';
import Employees from 'modules/employees/Employees';
import ForgotPassword from 'modules/forgotpassword/ForgotPassword';
import Onboarding from 'modules/onboarding';
import Register from 'modules/register';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { useAppSelector } from 'store';
import { appGeneralLoadingSelector } from 'store/selectors/app-selectors';
import { onboardingSelector } from 'store/selectors/employee-selector';
import MobileRedirectWrapper from './MobileRedirectWrapper';

const ContainerRoutes = () => {
  const employeeOnboarding = useAppSelector(onboardingSelector);
  const requestsLoading = useAppSelector(appGeneralLoadingSelector);
  if (employeeOnboarding) {
    return (
      <AppContainer>
        <Backdrop open={requestsLoading} sx={{ zIndex: 9000, color: '#fff' }} transitionDuration={300}>
          <UPLoadingSpinner />
        </Backdrop>
        <Outlet />
      </AppContainer>
    );
  }
  return <Outlet />;
};

const AuthRouter = (): JSX.Element => {
  return (
    <Routes>
      <Route path="/employees-app" element={<EmployeeApp />} />
      <Route path="/set-password-app" element={<SetPasswordApp />} />
      <Route element={<ContainerRoutes />}>
        <Route
          path="/employees/:companyToken/:inviteToken"
          element={<MobileRedirectWrapper Component={Employees} redirectPath="/employees-app" />}
        />
        <Route
          path="/employees/:generalToken"
          element={<MobileRedirectWrapper Component={Employees} redirectPath="/employees-app" />}
        />
      </Route>
      <Route
        path="/auth/set-password/:uniqueKey"
        element={<MobileRedirectWrapper Component={SetPassword} redirectPath="/set-password-app" />}
      />
      <Route
        path="/auth/set-manager-password/:uniqueKey"
        element={<MobileRedirectWrapper Component={SetManagerPassword} redirectPath="/set-password-app" />}
      />
      <Route
        path="/document-preview/:id"
        element={<MobileRedirectWrapper Component={Auth} redirectPath="/employees-app" />}
      />
      <Route path="/planning" element={<MobileRedirectWrapper Component={Auth} redirectPath="/employees-app" />} />
      <Route path="/auth/login" element={<Auth />} />
      {/* Deliberately not wrapped in MobileRedirectWrapper, unlike set-password: there is no mobile
          web target to redirect to, and a phone browser should get these screens — on enrollment the
          manual secret matters more than the QR, and the native app is never sent a challenge. */}
      <Route path="/auth/mfa-enrollment" element={<MfaEnrollment />} />
      <Route path="/auth/mfa-challenge" element={<MfaChallenge />} />
      <Route path="/redirect" element={<AuthRedirect />} />
      <Route path="/auth/register" element={<Register />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="*" element={<Navigate to="/auth/login" />} />
    </Routes>
  );
};

export default AuthRouter;
